/**
 * Comparator function for sorting strings with null/undefined handling.
 * @param a - First string value
 * @param b - Second string value
 * @returns Sort order (-1, 0, 1)
 */
export const sortingStringFn = (a?: string, b?: string) => {
  if (!a && !b) return 0
  if (!a) return -1
  if (!b) return 1

  if (typeof a === 'string' && typeof b === 'string') {
    return a.localeCompare(b)
  }
  return 0
}

/**
 * Comparator function for sorting numbers with null/undefined handling.
 * @param a - First number value
 * @param b - Second number value
 * @returns Sort order (-1, 0, 1)
 * @internal
 */
export const sortingNumberFn = (a?: number, b?: number) => {
  if (!a && !b) return 0
  if (!a) return -1
  if (!b) return 1
  return a - b
}

/**
 * Comparator function for sorting BigInts with null/undefined handling.
 * @param a - First BigInt value
 * @param b - Second BigInt value
 * @returns Sort order (-1, 0, 1)
 */
export const sortingBigIntFn = (a?: bigint, b?: bigint) => {
  if (!a && !b) return 0
  if (!a) return -1
  if (!b) return 1

  if (a > b) return 1
  if (a < b) return -1
  return 0
}

/**
 * Sorts an array by a specific key in descending order with null handling.
 * @param key - Object key to sort by
 * @param array - Array to sort
 * @returns Sorted array (descending, nulls last)
 */
export const sortingOnKey = <T>(key: keyof T, array?: T[] | null): T[] => {
  if (!array) return []
  // oxlint-disable-next-line unicorn/no-array-sort -- intentional in-place mutation of caller's array
  return array.sort((a, b) => {
    if (!a[key]) return 1
    if (!b[key]) return -1
    if (a[key] && b[key]) {
      return a[key] > b[key] ? -1 : 1
    }
    return 0
  })
}
